// pkg195 — previewPaymentImport / commitPaymentImport (owner): POST /api/admin/payment-import/preview { csv, mappings?, agreement_dates? } and POST /api/admin/payment-import/commit { preview_token, include, mappings?, agreement_dates? } — delivered 2026-10-31
// pkg193 — accounting summary + activity (view_billing); client payment list accepts ?deposit_account=operating|trust — delivered 2026-10-31
// pkg191 — session recovery (D-S3): adminRequest/adminDownload see 403 + code AUTH_REQUIRED (pkg190: expired/invalid access JWT), call the single-flight refreshAccessToken() from utils/adminSession, and retry the original request ONCE with the new token; a terminal refresh failure has already fired lm:session-expired (AdminAuthContext signs out, login page explains), so the thrown error is only for the in-flight caller; the dozen raw-fetch upload/download paths below keep their own token read and ride refresh-on-wake (D-S4) instead — delivered 2026-10-31
// pkg185 — excludeBiller / restoreBiller / setDefaultBiller (opt-out billing eligibility + default biller, D-185a/b); addTeamMember/removeTeamMember kept as legacy aliases — delivered 2026-10-30
// pkg198 — client payment methods, autopay status, payment plans, and per-client retainer replenishment — delivered 2026-11-01
// pkg171c — lawpaySignupStart() (owner; returns the one-time 8am sign-up redirect) — delivered 2026-10-05
// pkg173 — lawpayReconcile (owner: run the fetch-based settlement reconcile now) — delivered 2026-10-03
// pkg172a — paymentRequests / createPaymentRequest / resendPaymentRequest / cancelPaymentRequest (LawPay emailed links, lane 2) — delivered 2026-10-03
// pkg171a — lawpayStatus / lawpayConnectStart / lawpayRefreshAccounts / lawpaySaveAccountMap / lawpaySetMode / lawpayDisconnect (LawPay merchant connection + operating/trust/eCheck slot map; status=view_billing, rest owner-only) — delivered 2026-10-02
// pkg165 — discoAnalysisPleadingPrefill + discoAnalysisPleading (POST → docx blob) — delivered 2026-08-23
// pkg163 — discoAnalysisResume(clientId, {drop_id, attest}) re-queues a paused MightyAnalyzer run from its server-side checkpoints — delivered 2026-08-21
// pkg161 — batched MightyAnalyzer upload: discoAnalysisDropStart / discoAnalysisDropAddFiles (one multipart batch) / discoAnalysisDropFinalize / discoAnalysisDropCancel — delivered 2026-08-20
// pkg159 — HQ marketing email methods: templates / lists CRUD / render / row exclude / mark-sent (cold) / send (existing) / suppression — delivered 2026-08-18
// pkg152 — PFR fallback filename now Putative_Father_Registry_Request.pdf (official DCS form fill) — delivered 2026-08-18
// pkg151 — HQ onboarding email methods: hqListOnboardingTemplates / hqPreviewOnboardingEmail / hqSendOnboardingEmail (platform-identity operator sends from the HQ portal) — delivered 2026-08-18
// pkg148 — generateAdoptionDoc fallback filenames per kind (Adoption_Petition / Adoption_Final_Decree / registry / consent) — delivered 2026-08-16
// pkg147 — HQ application queue methods: hqListApplications / hqApproveApplication (bar_verified confirm + credits/days) / hqRejectApplication (silent or notify) — delivered 2026-08-15
// pkg144 — stepparent adoption admin methods: getClientAdoptionIntake / saveClientAdoptionIntake / saveAdoptionAttorneyData / generateAdoptionDoc (petition|decree|pfr|consent; 409 ICWA_HOLD surfaced via err.code) — delivered 2026-08-11
// pkg127 — module sends accept recipientIds[] (staff multi-select), + sendClientAssetLedger, downloadClientBudget (filled xlsx), downloadClientWitnesses (plain docx) — delivered 2026-07-27
// pkg125 — Client Modules workspace methods: module saves (budget/witnesses/demographic/parenting-plan/juvenile-info), admin asset-ledger CRUD + taxonomy + download, saveClientCaption, generateClientPleading (filename from X-Pleading-Filename) — delivered 2026-07-27
// pkg105a — listSessions / revokeSession (the pkg105 device-session registry: My Account "Signed-in devices" card, D-105a-2) — delivered 2026-07-25
// pkg100 — uploadFirmModule gains opts.quote_only (D-100f: the priced confirm gate — same multipart, zero spend, returns {credits, free_action_available, credit_balance}); reextractFirmModuleQuote added (D-100g); both real calls now return 202 with the row in extract_state='extracting' — delivered 2026-07-18
// pkg98 — MightyExchange methods: exchangeBrowse / exchangeGet / exchangeMine / exchangePublish (422 EXCHANGE_SCAN_BLOCKED carries hits) / exchangeAdopt / exchangeWithdraw + HQ moderation (hqExchangeList / hqExchangeReview / hqExchangeFeature) — delivered 2026-07-18
// pkg90 — firmExportStatus / firmExportRun / firmExportRegenerate / firmExportDownload (full firm data export, D-90a–h) — delivered 2026-07-18
// pkg71 — getReferrals: the Firm Wallet "Refer a firm" card (code, link, give/get amounts, referral list — D-71d) — delivered 2026-07-16
// pkg87 — HQ growth methods: hqSuspendFirm / hqSetExemption (typed-subdomain confirm, D-87p/q) / hqListInvites / hqCreateInvite / hqRevokeInvite (D-87j-o) / hqListSubdomainReviews / hqResolveSubdomainReview (D-87s/t) — delivered 2026-07-15
// pkg83 — discoAnalysisRequestsUpload (Step 1 of a deficiency run: the firm's served Word/PDF) + discoAnalysisLetter (draft letter download) — delivered 2026-07-14
// pkg81 — discoAnalysisInspect / discoAnalysisRun / discoAnalysisReports / discoAnalysisDocx (Discovery Analysis v1) — delivered 2026-07-14
// pkg79 — hqListFirms / hqExtendTrial (LawMighty HQ operator portal, platform-owner only) — delivered 2026-07-13
// pkg77 — getExpenseWorkProduct (archived AI work product attached to a billed expense, D-77d) — delivered 2026-07-13
// pkg76 — getClientCaseDigest / generateClientCaseDigest (cross-module case digest) — delivered 2026-07-13
// pkg75 — summarizeFirmModuleSubmission (per-submission AI summary) + draftClientCorrespondence (per-client letter drafts); both 1 credit, consume-on-success — delivered 2026-07-13
// pkg68 — createCreditsCheckout(quantity) sends the in-portal pack count; getFirmBillingLedger for the Firm Wallet history (D-68a/d/i) — delivered 2026-07-12
// pkg67b — six orphaned case-type mutation methods removed with AdminCaseTypesPage (endpoints 410'd since Package 12d); listCaseTypes/getCaseType reads stay (D-67b8) — delivered 2026-07-12
// pkg67 — getModulesCatalogMeta (platform_owner flag) + enableFirmModule / disableFirmModule (the firm's module choice toggles) — delivered 2026-07-12
// pkg65 — firm billing methods (status / checkout / credits-checkout / portal) + 402 SUBSCRIPTION_REQUIRED dispatches the paywall event (D-65d/i) — delivered 2026-07-11
// pkg57 — shareFirmModuleSubmission / unshareFirmModuleSubmission (push a completed document to a client's portal) — delivered 2026-07-09
// pkg50 — savePrepare carries the document's responsible attorney (attorney_user_id) — delivered 2026-07-09
// pkg46 — savePrepare carries the optional attorney signing act (typed name) — delivered 2026-07-05
// pkg43 — completed_by on upload; getPrepare/savePrepare (attorney fields per client) — delivered 2026-07-04
// pkg42 — submission management: deleteFirmModuleSubmission / updateFirmModuleSubmission (attorney edit of answers) — delivered 2026-07-04
// pkg41 — acknowledgment downloads: acknowledged snapshot copy + Certificate of Acknowledgment — delivered 2026-07-04
// pkg39 — reextractFirmModule (exact-fill re-extraction of the stored original) — delivered 2026-07-03
// pkg36 — createInternalSubmission (staff fill of internal modules) — delivered 2026-07-03
// pkg35 — assembly module methods: upload opts (kind/audience/practice area), practice-areas meta, original-file download — delivered 2026-07-03
// pkg33 — ethical wall methods (getClientBlocks / blockClientUser / unblockClientUser) — delivered 2026-06-24
// pkg32 — Emergency Alert methods (getFirmAlert / saveFirmAlert)
// pkg24 — removed dead trust-reconciliation stubs (getTrustReconPreview/listTrustRecons/createTrustRecon) — delivered 2026-06-14
// pkg23 — downloadDivorceCertificate method — delivered 2026-06-12
// pkg21a — case-type auto-assignment methods (get/set/apply) — delivered 2026-06-11
// pkg21 — 12 firm-module methods added (the 9 deliberately left out of pkg19b + clients/assign/unassign) — delivered 2026-06-11
// pkg20a — fix token storage reads (sessionStorage + localStorage persistent token); master key (x-admin-key) removed — delivered 2026-06-10
// All admin API calls go through this module. (Lineage: pkg19b restoration.)
//
// Auth: each request includes a Bearer JWT (per-user admin login). The token
// lives in sessionStorage ('ryanlaw_admin_token') for non-persistent sessions
// or localStorage ('ryanlaw_admin_token_p') when "Stay logged in" was checked
// — BOTH locations must be read (mirrors AdminAuthContext.getStoredToken).
// The legacy x-admin-key master password was removed in pkg20a.

import { refreshAccessToken } from './adminSession'; // pkg191

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:3001';

function getAuthHeaders() {
  const token = sessionStorage.getItem('ryanlaw_admin_token') || localStorage.getItem('ryanlaw_admin_token_p');
  if (token) return { Authorization: `Bearer ${token}` };
  return {};
}

// pkg191 (D-S3): true when the response is the backend's Phase-1 "your token
// is dead" answer (pkg190 code) and we haven't retried this call yet.
function isAuthRequired(res, data) {
  return res.status === 403 && data && data.code === 'AUTH_REQUIRED';
}

async function adminRequest(path, options = {}) {
  const { _retried, ...opts } = options;
  const res = await fetch(`${BASE}${path}`, {
    ...opts,
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders(),
      ...opts.headers,
    },
  });
  const data = await res.json();
  if (!res.ok) {
    // pkg191 (D-S3): expired access token → one refresh → one retry. The
    // refresh is single-flight, so a page that fires 20 requests at once
    // rotates the refresh token exactly once. If refresh fails the session
    // is already being torn down by AdminAuthContext; just throw.
    if (!_retried && isAuthRequired(res, data)) {
      const fresh = await refreshAccessToken();
      if (fresh) return adminRequest(path, { ...opts, _retried: true });
    }
    // pkg65 — a 402 means the firm's trial ended with no subscription.
    // Broadcast it so AdminLayout swaps the content area for the paywall;
    // the request still throws below so in-flight callers fail cleanly.
    if (res.status === 402 && data.code === 'SUBSCRIPTION_REQUIRED') {
      window.dispatchEvent(new CustomEvent('lm:subscription-required'));
    }
    // Phase 2: preserve structured error fields (status, code, current row
    // for 409 VERSION_CONFLICT) on the thrown error so callers can render a
    // conflict modal without doing fragile message-matching. Phase 1
    // callers continue to read err.message exactly as before.
    const serverError = typeof data.error === 'string' ? data.error : '';
    const err = new Error(serverError || 'Request failed');
    err.status  = res.status;
    err.code    = data.code;
    err.serverError = serverError;
    err.current = data.current;
    err.hits    = data.hits || (data.scan && data.scan.hits); // pkg98 — EXCHANGE_SCAN_BLOCKED
    err.pending_count = data.pending_count;
    err.pending_limit = data.pending_limit;
    throw err;
  }
  return data;
}

async function adminDownload(path, options = {}) {
  const { _retried, ...opts } = options;
  const res = await fetch(`${BASE}${path}`, {
    ...opts,
    headers: {
      ...getAuthHeaders(),
      ...(opts.headers || {}),
    },
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Download failed' }));
    if (!_retried && isAuthRequired(res, err)) { // pkg191 (D-S3)
      const fresh = await refreshAccessToken();
      if (fresh) return adminDownload(path, { ...opts, _retried: true });
    }
    if (res.status === 402 && err.code === 'SUBSCRIPTION_REQUIRED') { // pkg65
      window.dispatchEvent(new CustomEvent('lm:subscription-required'));
    }
    throw new Error(err.error || 'Download failed');
  }
  return res.blob();
}

// Drop empty values so optional filters (from, to, deposit_account, account, client_id)
// are omitted rather than sent as blank query params.
function queryString(params) {
  const u = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && String(v) !== '') u.set(k, String(v));
  });
  const s = u.toString();
  return s ? '?' + s : '';
}

export const adminApi = {
  // Client management
  createClient:  (fields)            => adminRequest('/api/admin/clients', { method: 'POST', body: JSON.stringify(fields) }),
  // listClients accepts an optional status filter:
  //   undefined / no arg → defaults to 'active' on the server (Closed Files
  //                          are hidden from every page that calls this).
  //   'closed_or_settled' → for the Closed Files page.
  //   'all' / 'active' / 'closed' / 'settled' → explicit overrides.
  listClients:   (status)            => {
    const qs = status ? `?status=${encodeURIComponent(status)}` : '';
    return adminRequest('/api/admin/clients' + qs);
  },
  getClient:     (id)                => adminRequest(`/api/admin/clients/${id}`),
  updateClient:  (id, fields)        => adminRequest(`/api/admin/clients/${id}`, { method: 'PATCH', body: JSON.stringify(fields) }),
  resetPassword: (id, newPassword)   => adminRequest(`/api/admin/clients/${id}/reset-password`, { method: 'POST', body: JSON.stringify({ newPassword }) }),
  sendWelcome:   (id, tempPassword)  => adminRequest(`/api/admin/clients/${id}/send-welcome`, { method: 'POST', body: JSON.stringify({ tempPassword }) }),
  deleteClient:  (id)                => adminRequest(`/api/admin/clients/${id}`, { method: 'DELETE' }),

  // Case lifecycle (Closed Files)
  closeClient:   (id)                => adminRequest(`/api/admin/clients/${id}/close`,  { method: 'POST' }),
  settleClient:  (id)                => adminRequest(`/api/admin/clients/${id}/settle`, { method: 'POST' }),
  reopenClient:  (id)                => adminRequest(`/api/admin/clients/${id}/reopen`, { method: 'POST' }),

  // pkg33 — ethical wall (per-client staff access blocks). Owner-only on the
  // backend. getClientBlocks returns { staff: [{ id, name, role, blockable,
  // blocked, reason, blocked_at }] }.
  getClientBlocks:   (clientId)                     => adminRequest(`/api/admin/clients/${clientId}/blocks`),
  blockClientUser:   (clientId, adminUserId, reason) => adminRequest(`/api/admin/clients/${clientId}/blocks`, { method: 'POST', body: JSON.stringify({ admin_user_id: adminUserId, reason }) }),
  unblockClientUser: (clientId, userId)             => adminRequest(`/api/admin/clients/${clientId}/blocks/${userId}`, { method: 'DELETE' }),

  // Client links (admin)
  getLinks:   (clientId)             => adminRequest(`/api/links/admin/${clientId}`),
  addLink:    (clientId, label, url) => adminRequest(`/api/links/admin/${clientId}`, { method: 'POST', body: JSON.stringify({ label, url }) }),
  deleteLink: (linkId)               => adminRequest(`/api/links/admin/${linkId}`, { method: 'DELETE' }),

  // View client data (admin impersonation)
  getClientDemographic:   (id) => adminRequest(`/api/admin/clients/${id}/demographic`),
  getClientParentingPlan: (id) => adminRequest(`/api/admin/clients/${id}/parenting-plan`),
  getClientWitnesses:     (id) => adminRequest(`/api/admin/clients/${id}/witnesses`),
  getClientBudget:        (id) => adminRequest(`/api/admin/clients/${id}/budget`),
  getClientAssetLedger:   (id) => adminRequest(`/api/admin/clients/${id}/asset-ledger`), // pkg29
  getClientJuvenileInfo:  (id) => adminRequest(`/api/admin/clients/${id}/juvenile-info`),

  // ── pkg125 — firm works the client's modules (Client Modules workspace) ───
  // Saves NEVER touch submitted_at (D-124e). Ledger CRUD shares the client
  // surface's column whitelists server-side.
  saveClientBudget:        (id, data) => adminRequest(`/api/admin/clients/${id}/budget`,         { method: 'POST', body: JSON.stringify({ data }) }),
  saveClientWitnesses:     (id, data) => adminRequest(`/api/admin/clients/${id}/witnesses`,      { method: 'POST', body: JSON.stringify({ data }) }),
  saveClientDemographic:   (id, data) => adminRequest(`/api/admin/clients/${id}/demographic`,    { method: 'POST', body: JSON.stringify({ data }) }),
  saveClientParentingPlan: (id, data) => adminRequest(`/api/admin/clients/${id}/parenting-plan`, { method: 'POST', body: JSON.stringify({ data }) }),
  saveClientJuvenileInfo:  (id, data) => adminRequest(`/api/admin/clients/${id}/juvenile-info`,  { method: 'POST', body: JSON.stringify({ data }) }),

  getClientLedgerTaxonomy:   (id)               => adminRequest(`/api/admin/clients/${id}/asset-ledger/taxonomy`),
  addClientAsset:            (id, payload)      => adminRequest(`/api/admin/clients/${id}/asset-ledger/assets`,                 { method: 'POST', body: JSON.stringify(payload) }),
  updateClientAsset:         (id, itemId, p)    => adminRequest(`/api/admin/clients/${id}/asset-ledger/assets/${itemId}`,       { method: 'PUT',  body: JSON.stringify(p) }),
  deleteClientAsset:         (id, itemId)       => adminRequest(`/api/admin/clients/${id}/asset-ledger/assets/${itemId}`,       { method: 'DELETE' }),
  addClientLiability:        (id, payload)      => adminRequest(`/api/admin/clients/${id}/asset-ledger/liabilities`,            { method: 'POST', body: JSON.stringify(payload) }),
  updateClientLiability:     (id, itemId, p)    => adminRequest(`/api/admin/clients/${id}/asset-ledger/liabilities/${itemId}`,  { method: 'PUT',  body: JSON.stringify(p) }),
  deleteClientLiability:     (id, itemId)       => adminRequest(`/api/admin/clients/${id}/asset-ledger/liabilities/${itemId}`,  { method: 'DELETE' }),
  downloadClientAssetLedger: (id)               => adminDownload(`/api/admin/clients/${id}/asset-ledger/download`),

  saveClientCaption: (id, caption) => adminRequest(`/api/admin/clients/${id}/caption`, { method: 'PUT', body: JSON.stringify(caption) }),
  // kind ∈ 'income-expense' | 'witness-list' | 'asset-liability'. Returns a
  // .docx blob; the pleading filename rides the X-Pleading-Filename header,
  // so this one uses fetch directly rather than adminDownload.
  generateClientPleading: async (id, kind, params) => {
    const res = await fetch(`${BASE}/api/admin/clients/${id}/pleadings/${kind}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
      body: JSON.stringify(params),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({ error: 'Generation failed' }));
      if (res.status === 402 && err.code === 'SUBSCRIPTION_REQUIRED') {
        window.dispatchEvent(new CustomEvent('lm:subscription-required'));
      }
      throw new Error(err.error || 'Generation failed');
    }
    const header = res.headers.get('X-Pleading-Filename');
    const filename = header ? decodeURIComponent(header) : 'Pleading.docx';
    return { blob: await res.blob(), filename };
  },

  // ── Stepparent Adoption (pkg144) ────────────────────────────────────────
  // Intake read/save (firm-side, submitted_at never touched), the attorney
  // fill panel, and the four document generators. generateAdoptionDoc mirrors
  // generateClientPleading (filename via X-Pleading-Filename) and surfaces
  // the 409 ICWA_HOLD code so the panel can render the hold banner.
  getClientAdoptionIntake:  (id) => adminRequest(`/api/admin/clients/${id}/adoption-intake`),
  saveClientAdoptionIntake: (id, data) => adminRequest(`/api/admin/clients/${id}/adoption-intake`, { method: 'POST', body: JSON.stringify({ data }) }),
  saveAdoptionAttorneyData: (id, data) => adminRequest(`/api/admin/clients/${id}/adoption-attorney-data`, { method: 'POST', body: JSON.stringify({ data }) }),
  // kind ∈ 'petition' | 'decree' | 'pfr' | 'consent'
  generateAdoptionDoc: async (id, kind, params = {}) => {
    const res = await fetch(`${BASE}/api/admin/clients/${id}/adoption-docs/${kind}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
      body: JSON.stringify(params),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({ error: 'Generation failed' }));
      if (res.status === 402 && err.code === 'SUBSCRIPTION_REQUIRED') {
        window.dispatchEvent(new CustomEvent('lm:subscription-required'));
      }
      const e = new Error(err.error || 'Generation failed');
      e.code = err.code;
      e.status = res.status;
      throw e;
    }
    const header = res.headers.get('X-Pleading-Filename');
    // pkg148 — per-kind fallbacks matching the server's names (the header is
    // now CORS-exposed, but the fallback should never say Adoption_Document)
    const FALLBACKS = {
      petition: 'Adoption_Petition.docx',
      decree:   'Adoption_Final_Decree.docx',
      pfr:      'Putative_Father_Registry_Request.pdf', // pkg152 — official CS-0435 PDF
      consent:  'Consent_of_Child.docx',
    };
    const filename = header ? decodeURIComponent(header) : (FALLBACKS[kind] || 'Adoption_Petition.docx');
    return { blob: await res.blob(), filename };
  },

  // Trigger emails on behalf of client
  // pkg127 — every module send accepts optional recipientIds (admin_users
  // UUIDs, multi-select). Omitted/empty → the firm contact email, unchanged.
  sendClientDemographic:   (id, recipientIds) => adminRequest(`/api/admin/clients/${id}/send-demographic`,    { method: 'POST', body: JSON.stringify({ recipientIds }) }),
  sendClientParentingPlan: (id, recipientIds) => adminRequest(`/api/admin/clients/${id}/send-parenting-plan`, { method: 'POST', body: JSON.stringify({ recipientIds }) }),
  sendClientWitnesses:     (id, recipientIds) => adminRequest(`/api/admin/clients/${id}/send-witnesses`,      { method: 'POST', body: JSON.stringify({ recipientIds }) }),
  sendClientBudget:        (id, recipientIds) => adminRequest(`/api/admin/clients/${id}/send-budget`,         { method: 'POST', body: JSON.stringify({ recipientIds }) }),
  sendClientJuvenileInfo:  (id, recipientIds) => adminRequest(`/api/admin/clients/${id}/send-juvenile-info`,  { method: 'POST', body: JSON.stringify({ recipientIds }) }),
  sendClientAssetLedger:   (id, recipientIds) => adminRequest(`/api/admin/clients/${id}/send-asset-ledger`,   { method: 'POST', body: JSON.stringify({ recipientIds }) }), // pkg127
  downloadClientBudget:    (id) => adminDownload(`/api/admin/clients/${id}/budget/download`),    // pkg127 — FILLED workbook
  downloadClientWitnesses: (id) => adminDownload(`/api/admin/clients/${id}/witnesses/download`), // pkg127 — plain .docx

  // Activity log
  getActivityLog: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return adminRequest('/api/activity-log' + (qs ? '?' + qs : ''));
  },

  // ── pkg65 — Firm subscription billing (the $29.99/mo LawMighty plan) ──────
  // Backend: src/routes/firmBilling.js at /api/firm-billing. Status is open
  // to any admin (drives the past-due banner + paywall); the POSTs are
  // owner-only and return { url } for a full-page redirect to Stripe.
  getBillingStatus:           () => adminRequest('/api/firm-billing/status'),
  createSubscriptionCheckout: () => adminRequest('/api/firm-billing/checkout',         { method: 'POST' }),
  // pkg68 (D-68a/i) — quantity is chosen IN-PORTAL now (Firm Wallet stepper)
  // and sent to the backend, which passes it verbatim to Stripe Checkout.
  createCreditsCheckout:      (quantity = 1) => adminRequest('/api/firm-billing/credits-checkout', { method: 'POST', body: JSON.stringify({ quantity }) }),
  openBillingPortal:          () => adminRequest('/api/firm-billing/portal',           { method: 'POST' }),
  getFirmBillingLedger:       () => adminRequest('/api/firm-billing/ledger'), // pkg68 (D-68d/i) — wallet history
  getReferrals:               () => adminRequest('/api/firm-billing/referrals'), // pkg71 (D-71d) — "Refer a firm" card

  // Firm settings
  getFirmSettings:  ()       => adminRequest('/api/firm-settings'),
  saveFirmSettings: (data)   => adminRequest('/api/firm-settings', { method: 'PATCH', body: JSON.stringify(data) }),

  // pkg32 — Emergency Alert banner (owner-only). getFirmAlert returns the
  // stored state even while the alert is OFF (so the owner can edit before
  // turning it on); saveFirmAlert sets { active, message, level }.
  getFirmAlert:  ()       => adminRequest('/api/firm-alert'),
  saveFirmAlert: (data)   => adminRequest('/api/firm-alert', { method: 'PUT', body: JSON.stringify(data) }),

  // Discovery settings (firm-wide defaults for the Discovery Response generator —
  // currently just the preamble)
  getDiscoverySettings:  ()       => adminRequest('/api/discovery-settings'),
  saveDiscoverySettings: (data)   => adminRequest('/api/discovery-settings', { method: 'PATCH', body: JSON.stringify(data) }),

  // Admin users & roles
  getAdminUsers:        ()                    => adminRequest('/api/admin-users'),
  createAdminUser:      (data)                => adminRequest('/api/admin-users', { method: 'POST', body: JSON.stringify(data) }),
  updateAdminUser:      (id, data)            => adminRequest(`/api/admin-users/${id}`, { method: 'PATCH', body: JSON.stringify(data) }),
  resetAdminPassword:   (id, newPassword)     => adminRequest(`/api/admin-users/${id}/reset-password`, { method: 'POST', body: JSON.stringify({ newPassword }) }),
  deleteAdminUser:      (id)                  => adminRequest(`/api/admin-users/${id}`, { method: 'DELETE' }),
  getPermissions:       ()                    => adminRequest('/api/admin-users/permissions'),
  setPermission:        (role, key, enabled)  => adminRequest(`/api/admin-users/permissions/${role}/${key}`, { method: 'PATCH', body: JSON.stringify({ enabled }) }),
  getMyPermissions:     ()                    => adminRequest('/api/admin-users/my-permissions'),
  getUserPermissions:    (id)               => adminRequest(`/api/admin-users/${id}/permissions`),
  setUserPermission:     (id, key, enabled) => adminRequest(`/api/admin-users/${id}/permissions/${key}`, { method: 'PATCH', body: JSON.stringify({ enabled }) }),
  revertUserPermission:  (id, key)          => adminRequest(`/api/admin-users/${id}/permissions/${key}`, { method: 'DELETE' }),

  // Discovery generator
  generateDiscovery: (params) => adminDownload('/api/discovery/generate', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  }),

  // ── Tool B: AI-assisted outgoing discovery ────────────────────────────────
  // draft: multipart (complaint + optional supporting[]/exemplar + fields) →
  //        JSON { questions, counts, model, generationId, ... }.
  // generate: JSON (approved questions + case fields) → .docx blob.
  aiDiscoveryDraft: async (fd) => {
    const token   = sessionStorage.getItem('ryanlaw_admin_token') || localStorage.getItem('ryanlaw_admin_token_p');
    const headers = {};
    if (token) headers.Authorization = `Bearer ${token}`;
    const BASE = process.env.REACT_APP_API_URL || 'http://localhost:3001';
    const res = await fetch(`${BASE}/api/discovery/ai/draft`, { method: 'POST', headers, body: fd });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      const err = new Error(data.error || 'Draft failed');
      err.status = res.status;
      err.code = data.code;
      throw err;
    }
    return data;
  },
  aiDiscoveryGenerate: (params) => adminDownload('/api/discovery/ai/generate', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  }),
  getAiDiscoveryPricing: () => adminRequest('/api/discovery/ai/pricing'),

  // ── Standard Discovery Sets (Tool A increment 3) ──────────────────────────
  // Firm-owner editor for the firm's own outgoing-discovery question sets
  // (pkg17 discovery_templates + discovery_template_questions). These are the
  // firm's blank boilerplate interrogatories/RFPs that POST /api/discovery/
  // generate fills into a real case — not client data.
  getDiscoveryTemplateMeta:   ()                  => adminRequest('/api/discovery-templates/meta'),
  // Auto-select + override options for a case's Generate Discovery panel.
  getDiscoverySetForClient:   (clientId)          => adminRequest(`/api/discovery-templates/for-client/${clientId}`),
  listDiscoveryTemplates:     ()                  => adminRequest('/api/discovery-templates'),
  getDiscoveryTemplate:       (id)                => adminRequest(`/api/discovery-templates/${id}`),
  createDiscoveryTemplate:    (fields)            => adminRequest('/api/discovery-templates',
    { method: 'POST', body: JSON.stringify(fields) }),
  updateDiscoveryTemplate:    (id, fields)        => adminRequest(`/api/discovery-templates/${id}`,
    { method: 'PATCH', body: JSON.stringify(fields) }),
  deleteDiscoveryTemplate:    (id)                => adminRequest(`/api/discovery-templates/${id}`,
    { method: 'DELETE' }),
  addDiscoveryTemplateQuestion:    (id, fields)       => adminRequest(`/api/discovery-templates/${id}/questions`,
    { method: 'POST', body: JSON.stringify(fields) }),
  updateDiscoveryTemplateQuestion: (id, qid, fields) => adminRequest(`/api/discovery-templates/${id}/questions/${qid}`,
    { method: 'PATCH', body: JSON.stringify(fields) }),
  deleteDiscoveryTemplateQuestion: (id, qid)          => adminRequest(`/api/discovery-templates/${id}/questions/${qid}`,
    { method: 'DELETE' }),
  reorderDiscoveryTemplateQuestions: (id, ids)        => adminRequest(`/api/discovery-templates/${id}/questions/reorder`,
    { method: 'POST', body: JSON.stringify({ ids }) }),

  // ── Tool A: the firm's uploaded standard discovery document ───────────────
  uploadDiscoveryTemplateDocument: async (id, file) => {
    const token   = sessionStorage.getItem('ryanlaw_admin_token') || localStorage.getItem('ryanlaw_admin_token_p');
    const headers = {};
    if (token) headers.Authorization = `Bearer ${token}`;
    const BASE = process.env.REACT_APP_API_URL || 'http://localhost:3001';
    const fd = new FormData();
    fd.append('file', file);
    const res = await fetch(`${BASE}/api/discovery-templates/${id}/document`, {
      method: 'POST', headers, body: fd,
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.error || 'Upload failed');
    return data;
  },
  getDiscoveryTemplateFields:    (id, clientId) => adminRequest(`/api/discovery-templates/${id}/document/fields${clientId ? `?client_id=${encodeURIComponent(clientId)}` : ''}`),
  deleteDiscoveryTemplateDocument: (id) => adminRequest(`/api/discovery-templates/${id}/document`, { method: 'DELETE' }),

  // ── Case-type-centric document API (redesigned Standard Discovery page) ────
  listDiscoveryDocuments: () => adminRequest('/api/discovery-templates/by-case-type/documents'),
  uploadDiscoveryDocByCaseType: async (caseTypeId, file) => {
    const token   = sessionStorage.getItem('ryanlaw_admin_token') || localStorage.getItem('ryanlaw_admin_token_p');
    const headers = {};
    if (token) headers.Authorization = `Bearer ${token}`;
    const BASE = process.env.REACT_APP_API_URL || 'http://localhost:3001';
    const fd = new FormData();
    fd.append('file', file);
    const res = await fetch(`${BASE}/api/discovery-templates/by-case-type/${caseTypeId}/document`, {
      method: 'POST', headers, body: fd,
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.error || 'Upload failed');
    return data;
  },
  deleteDiscoveryDocByCaseType: (caseTypeId) =>
    adminRequest(`/api/discovery-templates/by-case-type/${caseTypeId}/document`, { method: 'DELETE' }),
  reassignDiscoveryDoc: (caseTypeId, targetCaseTypeId) =>
    adminRequest(`/api/discovery-templates/by-case-type/${caseTypeId}/reassign`,
      { method: 'POST', body: JSON.stringify({ targetCaseTypeId }) }),
  downloadDiscoveryDocByCaseType: async (caseTypeId, filename) => {
    const token   = sessionStorage.getItem('ryanlaw_admin_token') || localStorage.getItem('ryanlaw_admin_token_p');
    const headers = {};
    if (token) headers.Authorization = `Bearer ${token}`;
    const BASE = process.env.REACT_APP_API_URL || 'http://localhost:3001';
    const res = await fetch(`${BASE}/api/discovery-templates/by-case-type/${caseTypeId}/document`, { headers });
    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      throw new Error(data.error || 'Download failed');
    }
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = filename || 'discovery.docx';
    document.body.appendChild(a); a.click(); a.remove();
    URL.revokeObjectURL(url);
  },

  // ── Firm practice areas (which areas the firm engages in) ─────────────────
  getFirmPracticeAreas: ()    => adminRequest('/api/firm-practice-areas'),
  setFirmPracticeAreas: (ids) => adminRequest('/api/firm-practice-areas', { method: 'PUT', body: JSON.stringify({ practice_area_ids: ids }) }),
  createFirmPracticeArea: (label)     => adminRequest('/api/firm-practice-areas/custom', { method: 'POST', body: JSON.stringify({ label }) }),
  renameFirmPracticeArea: (id, label) => adminRequest(`/api/firm-practice-areas/custom/${id}`, { method: 'PATCH', body: JSON.stringify({ label }) }),
  deleteFirmPracticeArea: (id)        => adminRequest(`/api/firm-practice-areas/custom/${id}`, { method: 'DELETE' }),

  // ── Firm case types (the firm's enabled list + its own custom types) ──────
  getFirmCaseTypes:    ()          => adminRequest('/api/firm-case-types'),
  createFirmCaseType:  (fields)    => adminRequest('/api/firm-case-types/custom', { method: 'POST', body: JSON.stringify(fields) }),
  loadStarterCaseTypes: (fields)   => adminRequest('/api/firm-case-types/load-starters', { method: 'POST', body: JSON.stringify(fields) }),
  updateFirmCaseType:  (id, fields) => adminRequest(`/api/firm-case-types/custom/${id}`, { method: 'PATCH', body: JSON.stringify(fields) }),
  deleteFirmCaseType:  (id)        => adminRequest(`/api/firm-case-types/custom/${id}`, { method: 'DELETE' }),

  // Clio import sessions
  getSessions:           ()                        => adminRequest('/api/import/sessions'),
  createSession:         (label)                   => adminRequest('/api/import/sessions', { method: 'POST', body: JSON.stringify({ label }) }),
  getSession:            (id)                      => adminRequest(`/api/import/sessions/${id}`),
  previewMatters:        (csvText)                 => adminRequest('/api/import/matters/preview',  { method: 'POST', body: JSON.stringify({ csvText }) }),
  executeMatters:        (sessionId, rows, importAsClosed) =>
    adminRequest('/api/import/matters/execute', {
      method: 'POST',
      body: JSON.stringify({ sessionId, rows, importAsClosed }),
    }),
  previewContacts:       (sessionId, csvText)      => adminRequest('/api/import/contacts/preview', { method: 'POST', body: JSON.stringify({ sessionId, csvText }) }),
  executeContacts:       (sessionId, matches)      => adminRequest('/api/import/contacts/execute', { method: 'POST', body: JSON.stringify({ sessionId, matches }) }),
  previewActivities:     (sessionId, csvText)      => adminRequest('/api/import/activities/preview', { method: 'POST', body: JSON.stringify({ sessionId, csvText }) }),
  executeActivities:     (sessionId, entries)      => adminRequest('/api/import/activities/execute', { method: 'POST', body: JSON.stringify({ sessionId, entries }) }),
  previewBills:          (sessionId, csvText)      => adminRequest('/api/import/bills/preview',      { method: 'POST', body: JSON.stringify({ sessionId, csvText }) }),
  executeBills:          (sessionId, bills)        => adminRequest('/api/import/bills/execute',      { method: 'POST', body: JSON.stringify({ sessionId, bills }) }),
  previewTrust:          (sessionId, csvText)      => adminRequest('/api/import/trust/preview',      { method: 'POST', body: JSON.stringify({ sessionId, csvText }) }),
  executeTrust:          (sessionId, transactions) => adminRequest('/api/import/trust/execute',      { method: 'POST', body: JSON.stringify({ sessionId, transactions }) }),

  // Contacts importer — personal/professional contacts from Google or Apple.
  // Separate from Clio import; writes to the `contacts` table, not `clients`.
  // `format` is 'auto' | 'vcard' | 'google_csv' | 'outlook_csv'.
  previewContactsImport: (text, filename, format = 'auto') =>
    adminRequest('/api/contacts-import/preview', {
      method: 'POST',
      body: JSON.stringify({ text, filename, format }),
    }),
  executeContactsImport: (rows) =>
    adminRequest('/api/contacts-import/execute', {
      method: 'POST',
      body: JSON.stringify({ rows }),
    }),
  getContactsImportRecent: () => adminRequest('/api/contacts-import/recent'),

  // Contacts directory — browse, view, delete, convert, export.
  listContacts: ({ q = '', source = '', tag = '', converted = '', page = 1, pageSize = 25, sort = 'name_asc' } = {}) => {
    const qs = new URLSearchParams();
    if (q)         qs.set('q', q);
    if (source)    qs.set('source', source);
    if (tag)       qs.set('tag', tag);
    if (converted) qs.set('converted', converted);
    qs.set('page', String(page));
    qs.set('pageSize', String(pageSize));
    qs.set('sort', sort);
    return adminRequest('/api/contacts?' + qs.toString());
  },
  getContact:           (id)              => adminRequest(`/api/contacts/${id}`),
  deleteContact:        (id)              => adminRequest(`/api/contacts/${id}`, { method: 'DELETE' }),
  bulkDeleteContacts:   (ids, confirm)    => adminRequest('/api/contacts/bulk-delete', { method: 'POST', body: JSON.stringify({ ids, confirm }) }),
  deleteAllContacts:    (confirm)         => adminRequest('/api/contacts/delete-all', { method: 'POST', body: JSON.stringify({ confirm }) }),
  linkContactToClient:  (contactId, clientId) =>
    adminRequest(`/api/contacts/${contactId}/convert-to-client`, { method: 'POST', body: JSON.stringify({ clientId }) }),
  exportContacts:       ({ ids, format }) =>
    adminRequest('/api/contacts/export', { method: 'POST', body: JSON.stringify({ ids, format }) }),

  // Conflict checker. Every check must be linked to a client.
  // runConflictCheck body shape:
  //   { clientId, primary: { name, email?, phone? },
  //     related?: [{ relation?, name, email?, phone? }] }
  runConflictCheck:           (body)        => adminRequest('/api/conflict-check/run', { method: 'POST', body: JSON.stringify(body) }),
  listConflictChecksForClient:(clientId)    => adminRequest(`/api/conflict-check/client/${clientId}`),
  getConflictCheck:           (id)          => adminRequest(`/api/conflict-check/${id}`),

  // Mass email
  sendMassEmail: (subject, body, recipients) => adminRequest('/api/admin/mass-email', { method: 'POST', body: JSON.stringify({ subject, body, recipients: recipients || null }) }),

  // Global dates (all clients)
  getGlobalDates:    ()                           => adminRequest('/api/global-dates/admin'),
  addGlobalDate:     (entry)                      => adminRequest('/api/global-dates/admin', { method: 'POST', body: JSON.stringify(entry) }),
  deleteGlobalDate:  (id)                         => adminRequest(`/api/global-dates/admin/${id}`, { method: 'DELETE' }),

  // Important dates
  getDates:   (clientId)                          => adminRequest(`/api/dates/admin/${clientId}`),
  addDate:    (clientId, date, desc, location, startTime, endTime) =>
    adminRequest(`/api/dates/admin/${clientId}`, {
      method: 'POST',
      body: JSON.stringify({
        date,
        description: desc,
        location: location || null,
        start_time: startTime || null,
        end_time:   endTime   || null,
      }),
    }),
  deleteDate: (dateId)                            => adminRequest(`/api/dates/admin/${dateId}`, { method: 'DELETE' }),

  // Client calendar feed (subscribe-to-iCal). Admin can see whether a
  // client has an active feed token and revoke it. The token itself is
  // intentionally NOT returned to admins — only the client sees their own
  // feed URL. Revoking is one-click and takes effect on the next poll.
  getClientCalendarSync:    (clientId) => adminRequest(`/api/calendar/admin/${clientId}`),
  revokeClientCalendarSync: (clientId) => adminRequest(`/api/calendar/admin/${clientId}`, { method: 'DELETE' }),

  // Billing
  getBilling:           (clientId)                       => adminRequest(`/api/billing/${clientId}`),
  addBillingEntry:      (clientId, entry)                => adminRequest(`/api/billing/${clientId}`, { method: 'POST', body: JSON.stringify(entry) }),
  // Wave 1 fix: edit-in-place support for time entries. Backend route is
  // PATCH /api/billing/entry/:id (defined in routes/billing.js).
  updateBillingEntry:   (entryId, fields)                 => adminRequest(`/api/billing/entry/${entryId}`, { method: 'PATCH', body: JSON.stringify(fields) }),
  deleteBillingEntry:   (entryId)                        => adminRequest(`/api/billing/entry/${entryId}`, { method: 'DELETE' }),
  setHourlyRate:        (clientId, rate)                 => adminRequest(`/api/billing/rate/${clientId}`, { method: 'PATCH', body: JSON.stringify({ hourly_rate: rate }) }),
  // Wave 2: combined update for client billing config — accepts any subset
  // of { hourly_rate, fee_type, flat_fee_amount }. Passing fee_type='hourly'
  // also clears flat_fee_amount on the server side.
  setBillingSettings:   (clientId, fields)                => adminRequest(`/api/billing/rate/${clientId}`, { method: 'PATCH', body: JSON.stringify(fields) }),
  setBillerRate:        (clientId, adminUserId, rate)    => adminRequest(`/api/billing/biller-rate/${clientId}`, { method: 'PATCH', body: JSON.stringify({ admin_user_id: adminUserId, hourly_rate: rate }) }),
  getAdminUsersPublic:  ()                               => adminRequest('/api/admin-users'),

  // Billing eligibility (pkg185 — opt-out; replaces team management)
  excludeBiller:    (clientId, adminUserId)             => adminRequest(`/api/billing/${clientId}/exclusions`, { method: 'POST', body: JSON.stringify({ admin_user_id: adminUserId }) }),
  restoreBiller:    (clientId, adminUserId)             => adminRequest(`/api/billing/${clientId}/exclusions/${adminUserId}`, { method: 'DELETE' }),
  setDefaultBiller: (clientId, adminUserId)             => adminRequest(`/api/billing/${clientId}/default-biller`, { method: 'PATCH', body: JSON.stringify({ admin_user_id: adminUserId || null }) }),
  // Legacy aliases (server maps add → restore, remove → exclude)
  addTeamMember:    (clientId, adminUserId, hourlyRate) => adminRequest(`/api/billing/${clientId}/team`, { method: 'POST', body: JSON.stringify({ admin_user_id: adminUserId, hourly_rate: hourlyRate }) }),
  removeTeamMember: (clientId, adminUserId)             => adminRequest(`/api/billing/${clientId}/team/${adminUserId}`, { method: 'DELETE' }),

  // Expenses
  listExpenses:    (clientId)             => adminRequest(`/api/expenses/client/${clientId}`),
  addExpense:      (clientId, expense)    => adminRequest(`/api/expenses/client/${clientId}`, { method: 'POST', body: JSON.stringify(expense) }),
  updateExpense:   (id, expense)          => adminRequest(`/api/expenses/${id}`, { method: 'PATCH', body: JSON.stringify(expense) }),
  deleteExpense:   (id)                   => adminRequest(`/api/expenses/${id}`, { method: 'DELETE' }),
  // pkg77 (D-77d) — the archived AI work product attached to a billed expense
  getExpenseWorkProduct: (id)             => adminRequest(`/api/expenses/${id}/work-product`),

  // Invoices
  listInvoices:           (params = {})    => {
    const qs = new URLSearchParams(params).toString();
    return adminRequest('/api/invoices' + (qs ? '?' + qs : ''));
  },
  listClientInvoices:     (clientId)       => adminRequest(`/api/invoices/client/${clientId}`),
  getInvoice:             (id)             => adminRequest(`/api/invoices/${id}`),
  previewInvoiceItems:    (clientId)       => adminRequest(`/api/invoices/preview/${clientId}`),
  createInvoice:          (payload)        => adminRequest('/api/invoices', { method: 'POST', body: JSON.stringify(payload) }),
  updateInvoice:          (id, fields)     => adminRequest(`/api/invoices/${id}`, { method: 'PATCH', body: JSON.stringify(fields) }),
  removeInvoiceLine:      (id, type, lineId) => adminRequest(`/api/invoices/${id}/remove-line`, { method: 'POST', body: JSON.stringify({ type, lineId }) }),
  issueInvoice:           (id)             => adminRequest(`/api/invoices/${id}/issue`,  { method: 'POST' }),
  voidInvoice:            (id, reason)     => adminRequest(`/api/invoices/${id}/void`,   { method: 'POST', body: JSON.stringify({ reason }) }),
  deleteInvoice:          (id)             => adminRequest(`/api/invoices/${id}`,        { method: 'DELETE' }),
  downloadInvoice:        (id)             => adminDownload(`/api/invoices/${id}/download`),
  emailInvoice:           (id, payload)    => adminRequest(`/api/invoices/${id}/email`,  { method: 'POST', body: JSON.stringify(payload) }),

  // Payments (Phase 2)
  listPayments:           (params = {})       => adminRequest('/api/payments' + queryString(params)),
  // pkg193 — optional { deposit_account: 'operating' | 'trust' }
  listClientPayments:     (clientId, params = {}) => adminRequest(`/api/payments/client/${clientId}` + queryString(params)),
  getPayment:             (id)                => adminRequest(`/api/payments/${id}`),
  previewPayment:         (clientId)          => adminRequest(`/api/payments/preview/${clientId}`),
  createPayment:          (clientId, payload) => adminRequest(`/api/payments/client/${clientId}`, { method: 'POST', body: JSON.stringify(payload) }),
  updatePayment:          (id, fields)        => adminRequest(`/api/payments/${id}`, { method: 'PATCH', body: JSON.stringify(fields) }),
  reversePayment:         (id, payload)       => {
    // Backward-compatible: accept either a plain reason string (legacy) or
    // a payload object { reason, reversal_date?, method?, reference_number? }.
    const body = typeof payload === 'string' ? { reason: payload } : (payload || {});
    return adminRequest(`/api/payments/${id}/reverse`, { method: 'POST', body: JSON.stringify(body) });
  },
  // Owner-only. Body is { amount, reason }. Partial refunds are allowed up to the refundable remainder.
  // A full-amount refund that LawPay can still void uses this same body. The
  // server calls LawPay's transaction void endpoint; the portal does not.
  refundPayment:          (id, payload)       => adminRequest(`/api/payments/${id}/refund`,  { method: 'POST', body: JSON.stringify(payload) }),
  addPaymentAllocation:   (id, invoiceId, amount) => adminRequest(`/api/payments/${id}/allocations`, { method: 'POST', body: JSON.stringify({ invoice_id: invoiceId, amount }) }),
  removePaymentAllocation:(id, allocId)       => adminRequest(`/api/payments/${id}/allocations/${allocId}`, { method: 'DELETE' }),

  // Wave 2: soft-void delete of a payment, plus full CRUD on refunds and
  // reversals (each row now has its own id and edit/delete actions).
  // "Delete" never hard-deletes — it sets status='voided' on the target row
  // and recalculates affected invoice balances. Voided rows stay in admin
  // history but are excluded from financial totals.
  deletePayment:          (id, voidReason)    => adminRequest(`/api/payments/${id}`, { method: 'DELETE', body: JSON.stringify({ void_reason: voidReason || null }) }),
  updateRefund:           (refundId, fields)  => adminRequest(`/api/payments/refunds/${refundId}`, { method: 'PATCH', body: JSON.stringify(fields) }),
  deleteRefund:           (refundId, voidReason) => adminRequest(`/api/payments/refunds/${refundId}`, { method: 'DELETE', body: JSON.stringify({ void_reason: voidReason || null }) }),
  updateReversal:         (reversalId, fields) => adminRequest(`/api/payments/reversals/${reversalId}`, { method: 'PATCH', body: JSON.stringify(fields) }),
  deleteReversal:         (reversalId, voidReason) => adminRequest(`/api/payments/reversals/${reversalId}`, { method: 'DELETE', body: JSON.stringify({ void_reason: voidReason || null }) }),

  downloadReceipt:        (id)                => adminDownload(`/api/payments/${id}/download`),
  emailReceipt:           (id, payload)       => adminRequest(`/api/payments/${id}/email`, { method: 'POST', body: JSON.stringify(payload) }),

  // Trust accounting (Phase 3)
  getTrustFirmSummary:    (params = {})       => {
    const qs = new URLSearchParams(params).toString();
    return adminRequest('/api/trust/firm-summary' + (qs ? '?' + qs : ''));
  },
  getClientTrust:         (clientId)          => adminRequest(`/api/trust/client/${clientId}`),
  getTrustTransaction:    (id)                => adminRequest(`/api/trust/${id}`),
  createTrustTransaction: (clientId, payload) => adminRequest(`/api/trust/client/${clientId}`, { method: 'POST', body: JSON.stringify(payload) }),
  updateTrustTransaction: (id, fields)        => adminRequest(`/api/trust/${id}`, { method: 'PATCH', body: JSON.stringify(fields) }),
  deleteTrustTransaction: (id)                => adminRequest(`/api/trust/${id}`, { method: 'DELETE' }),

  // pkg193 — firm accounting (view_billing). from/to optional YYYY-MM-DD.
  // summary → { from, to, firm:{ operating_received, trust_received, trust_disbursed, trust_balance, total_received }, clients:[...] }
  // activity → { rows:[{ date, client_id, client_name, account, type, description, amount, reference }] }
  // activity filters: client_id, account=operating|trust
  getAccountingSummary: (params = {}) => adminRequest('/api/accounting/summary' + queryString(params)),
  getAccountingActivity: (params = {}) => adminRequest('/api/accounting/activity' + queryString(params)),

  // pkg195 — owner-only accounting email-log import.
  // preview body: { csv, mappings?, agreement_dates? }
  // commit body:  { preview_token, include, mappings?, agreement_dates? }
  previewPaymentImport: (body) => adminRequest('/api/admin/payment-import/preview', {
    method: 'POST',
    body: JSON.stringify(body),
  }),
  commitPaymentImport: (body) => adminRequest('/api/admin/payment-import/commit', {
    method: 'POST',
    body: JSON.stringify(body),
  }),

  // Downloads
  downloadParentingPlan: (id) => adminDownload(`/api/admin/clients/${id}/download-parenting-plan`),
  downloadJuvenileInfo:  (id) => adminDownload(`/api/admin/clients/${id}/download-juvenile-info`),
  downloadDivorceCertificate: (id) => adminDownload(`/api/admin/clients/${id}/download-divorce-certificate`),
  downloadClientAssetLedger:  (id) => adminDownload(`/api/admin/clients/${id}/asset-ledger/download`), // pkg29

  // ── Discovery Response (Phase 1: attorney-only) ──
  listDiscoveryResponses:    (clientId)        => {
    const qs = clientId ? `?clientId=${encodeURIComponent(clientId)}` : '';
    return adminRequest(`/api/discovery-response${qs}`);
  },
  getDiscoveryResponse:      (id)              => adminRequest(`/api/discovery-response/${id}`),
  updateDiscoveryResponse:   (id, fields)      => adminRequest(`/api/discovery-response/${id}`,
    { method: 'PATCH', body: JSON.stringify(fields) }),
  deleteDiscoveryResponse:   (id)              => adminRequest(`/api/discovery-response/${id}`,
    { method: 'DELETE' }),

  // Upload is multipart — handled with a custom fetch (cannot use adminRequest
  // because that sets Content-Type: application/json which would break the
  // boundary header browsers set automatically for FormData).
  uploadDiscoveryResponse: async (formData) => {
    const token   = sessionStorage.getItem('ryanlaw_admin_token') || localStorage.getItem('ryanlaw_admin_token_p');
    const headers = {};
    if (token) headers.Authorization = `Bearer ${token}`;
    const BASE = process.env.REACT_APP_API_URL || 'http://localhost:3001';
    const res = await fetch(`${BASE}/api/discovery-response/upload`, {
      method: 'POST',
      headers,
      body: formData,
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      const err = new Error(data.error || 'Upload failed');
      err.code = data.code;
      throw err;
    }
    return data;
  },

  // Question CRUD
  addDiscoveryQuestion:      (responseId, fields)         => adminRequest(`/api/discovery-response/${responseId}/questions`,
    { method: 'POST', body: JSON.stringify(fields) }),
  updateDiscoveryQuestion:   (responseId, qid, fields)    => adminRequest(`/api/discovery-response/${responseId}/questions/${qid}`,
    { method: 'PATCH', body: JSON.stringify(fields) }),
  deleteDiscoveryQuestion:   (responseId, qid)            => adminRequest(`/api/discovery-response/${responseId}/questions/${qid}`,
    { method: 'DELETE' }),
  reorderDiscoveryQuestions: (responseId, ids)            => adminRequest(`/api/discovery-response/${responseId}/questions/reorder`,
    { method: 'POST', body: JSON.stringify({ ids }) }),

  // Answer update (with optimistic-locking version)
  saveDiscoveryAnswer: (responseId, qid, payload) => adminRequest(`/api/discovery-response/${responseId}/questions/${qid}/answer`,
    { method: 'PUT', body: JSON.stringify(payload) }),

  // Generate Word doc — downloads as .docx
  generateDiscoveryResponse: (responseId, payload) => adminDownload(`/api/discovery-response/${responseId}/generate`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  }),

  // ── Discovery Response — Phase 2 additions ────────────────────────────
  // Convenience wrapper around updateDiscoveryResponse for the visibility
  // toggle. The backend validates `status` against the allowed set and
  // writes an activity-log entry when it changes.
  setDiscoveryResponseStatus: (id, status) => adminRequest(`/api/discovery-response/${id}`,
    { method: 'PATCH', body: JSON.stringify({ status }) }),

  // Presence: read all current viewers for this response (admin filters its
  // own row out client-side to render only the "other party" indicator).
  getDiscoveryResponsePresence: (id) => adminRequest(`/api/discovery-response/${id}/presence`),

  // Presence: heartbeat. The current admin user is identified by the JWT;
  // body just needs the active question_id.
  sendDiscoveryResponsePresence: (id, questionId) => adminRequest(`/api/discovery-response/${id}/presence`,
    { method: 'POST', body: JSON.stringify({ question_id: questionId }) }),

  // ── Modules system (Phase 1 backend, Phase 2 admin UI) ────────────────

  // Module catalog
  listModules:        ()            => adminRequest('/api/modules/admin/catalog'),
  // pkg67 — owner/picker split support: meta flag + the firm's own module choice
  getModulesCatalogMeta: ()         => adminRequest('/api/modules/admin/catalog/meta'),
  enableFirmModule:   (id)          => adminRequest(`/api/modules/admin/catalog/${id}/firm-enabled`,
    { method: 'POST' }),
  disableFirmModule:  (id)          => adminRequest(`/api/modules/admin/catalog/${id}/firm-enabled`,
    { method: 'DELETE' }),
  getModule:          (id)          => adminRequest(`/api/modules/admin/catalog/${id}`),
  createModule:       (payload)     => adminRequest('/api/modules/admin/catalog',
    { method: 'POST', body: JSON.stringify(payload) }),
  updateModule:       (id, fields)  => adminRequest(`/api/modules/admin/catalog/${id}`,
    { method: 'PATCH', body: JSON.stringify(fields) }),
  reorderModules:     (items)       => adminRequest('/api/modules/admin/catalog/reorder',
    { method: 'POST', body: JSON.stringify({ items }) }),
  activateModule:     (id)          => adminRequest(`/api/modules/admin/catalog/${id}/activate`,
    { method: 'POST' }),
  deactivateModule:   (id)          => adminRequest(`/api/modules/admin/catalog/${id}/deactivate`,
    { method: 'POST' }),
  deleteModule:       (id)          => adminRequest(`/api/modules/admin/catalog/${id}`,
    { method: 'DELETE' }),

  // PDF upload — multipart, same pattern as uploadDiscoveryResponse.
  uploadModulePdf: async (id, file) => {
    const formData = new FormData();
    formData.append('file', file);
    const token   = sessionStorage.getItem('ryanlaw_admin_token') || localStorage.getItem('ryanlaw_admin_token_p');
    const headers = {};
    if (token) headers.Authorization = `Bearer ${token}`;
    const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
    const res = await fetch(`${BASE_URL}/api/modules/admin/catalog/${id}/pdf`, {
      method: 'POST',
      headers,
      body: formData,
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      const err = new Error(data.error || 'Upload failed');
      err.code = data.code;
      throw err;
    }
    return data;
  },

  // Admin-side PDF preview URL builder (returns a string for <iframe src>).
  // Note: admin auth via header isn't possible in an <iframe src>, so we
  // download the bytes and turn them into an object URL instead.
  fetchModulePdfBlob: (id) => adminDownload(`/api/modules/admin/catalog/${id}/pdf`),

  // Per-client module assignment
  getClientModules:           (clientId)             => adminRequest(`/api/modules/admin/clients/${clientId}`),
  setClientModules:           (clientId, enabledIds) => adminRequest(`/api/modules/admin/clients/${clientId}`,
    { method: 'PUT', body: JSON.stringify({ enabled_module_ids: enabledIds }) }),
  applyClientModuleTemplate:  (clientId, caseTypeId) => adminRequest(`/api/modules/admin/clients/${clientId}/apply-template`,
    { method: 'POST', body: JSON.stringify({ case_type_id: caseTypeId }) }),

  // Case types
  listCaseTypes:        ()                       => adminRequest('/api/case-types/admin'),
  getCaseType:          (id)                     => adminRequest(`/api/case-types/admin/${id}`),
  // pkg67b (D-67b8) — the six case-type MUTATION methods (create/update/
  // setModules/activate/deactivate/delete) were removed with their only
  // caller, AdminCaseTypesPage: the backend tombstoned those endpoints with
  // 410s in Package 12d. The two READS above stay — three live consumers
  // (client detail, create client, discovery sets).

  // ── pkg19b — methods the current pages call under newer names ────────────
  // A rename pass landed in the page components but never in this file.
  // The first eight hit the SAME backend endpoints as the older-named
  // methods above (getDates/addDate, getBilling/addBillingEntry,
  // listExpenses/addExpense, listClientInvoices, listClientPayments).
  getClientDates:     (clientId)        => adminRequest(`/api/dates/admin/${clientId}`),
  createDate: (clientId, date, desc, location, startTime, endTime) =>
    adminRequest(`/api/dates/admin/${clientId}`, {
      method: 'POST',
      body: JSON.stringify({
        date,
        description: desc,
        location: location || null,
        start_time: startTime || null,
        end_time:   endTime   || null,
      }),
    }),
  getBillingEntries:  (clientId)        => adminRequest(`/api/billing/${clientId}`),
  createBillingEntry: (clientId, entry) => adminRequest(`/api/billing/${clientId}`,
    { method: 'POST', body: JSON.stringify(entry) }),
  getExpenses:        (clientId)        => adminRequest(`/api/expenses/client/${clientId}`),
  createExpense:      (clientId, exp)   => adminRequest(`/api/expenses/client/${clientId}`,
    { method: 'POST', body: JSON.stringify(exp) }),
  getClientInvoices:  (clientId)        => adminRequest(`/api/invoices/client/${clientId}`),
  // pkg193 — optional { deposit_account: 'operating' | 'trust' } on the client Billing payments list
  getClientPayments:  (clientId, params = {}) => adminRequest(`/api/payments/client/${clientId}` + queryString(params)),

  // ── pkg19b / pkg24 — PROVISIONAL: backend route does not exist yet ────────
  // The invoice fee-transfer button landed in the frontend, but its backend
  // route was never built (trust.js has no fee-transfer). This stub lets the
  // invoice page mount and show its own error banner instead of white-
  // screening on a missing method. When the backend feature is built, align
  // this path with the real route. (pkg24 removed the sibling trust-
  // reconciliation stubs + their page; that backend was likewise never built.)
  feeTransfer: (clientId, payload) =>
    adminRequest(`/api/trust/client/${clientId}/fee-transfer`,
      { method: 'POST', body: JSON.stringify(payload) }),

  // ── pkg21 — Firm-private AI modules (pkg18 re-land) ───────────────────────
  // Backend: src/routes/firmModules.js mounted at /api/firm-modules; every
  // admin path lives under /admin (adminAuth rule: manage_modules). Paths
  // verified against the route file. Upload is multipart — custom fetch with
  // the two-storage token read (brief, decision 57), same pattern as
  // uploadDiscoveryResponse.
  listFirmModules:   ()           => adminRequest('/api/firm-modules/admin'),
  getFirmModule:     (id)         => adminRequest(`/api/firm-modules/admin/${id}`),
  // pkg35 — opts: { kind: 'assembly'|'form', audience: 'client'|'internal',
  // practice_area_id }. Omitted opts preserve the legacy 'form' behavior.
  uploadFirmModule: async (file, label, description, opts = {}) => {
    const fd = new FormData();
    fd.append('file', file);
    if (label)       fd.append('label', label);
    if (description) fd.append('description', description);
    if (opts.kind)             fd.append('kind', opts.kind);
    if (opts.audience)         fd.append('audience', opts.audience);
    if (opts.practice_area_id) fd.append('practice_area_id', opts.practice_area_id);
    if (opts.completed_by)     fd.append('completed_by', opts.completed_by); // pkg43 — attorney | client | both
    if (opts.quote_only)       fd.append('quote_only', '1'); // pkg100 (D-100f) — priced quote, zero spend, no row
    const token   = sessionStorage.getItem('ryanlaw_admin_token') || localStorage.getItem('ryanlaw_admin_token_p');
    const headers = {};
    if (token) headers.Authorization = `Bearer ${token}`;
    const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
    const res = await fetch(`${BASE_URL}/api/firm-modules/admin/upload`, {
      method: 'POST',
      headers,
      body: fd,
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      const err = new Error(data.error || 'Upload failed');
      err.status = res.status;
      err.code = data.code;
      throw err;
    }
    return data;
  },
  updateFirmModule:     (id, fields) => adminRequest(`/api/firm-modules/admin/${id}`,
    { method: 'PATCH', body: JSON.stringify(fields) }),
  activateFirmModule:   (id)         => adminRequest(`/api/firm-modules/admin/${id}/activate`,
    { method: 'POST' }),
  deactivateFirmModule: (id)         => adminRequest(`/api/firm-modules/admin/${id}/deactivate`,
    { method: 'POST' }),
  deleteFirmModule:     (id)         => adminRequest(`/api/firm-modules/admin/${id}`,
    { method: 'DELETE' }),
  getFirmModuleClients: (id)         => adminRequest(`/api/firm-modules/admin/${id}/clients`),
  assignFirmModule:     (id, clientIds) => adminRequest(`/api/firm-modules/admin/${id}/assign`,
    { method: 'POST', body: JSON.stringify({ client_ids: clientIds }) }),
  unassignFirmModule:   (id, clientIds) => adminRequest(`/api/firm-modules/admin/${id}/unassign`,
    { method: 'POST', body: JSON.stringify({ client_ids: clientIds }) }),
  listFirmModuleSubmissions:    (id)  => adminRequest(`/api/firm-modules/admin/${id}/submissions`),
  // pkg75 — generate/re-generate the stored AI summary for one submission (1 credit, consume-on-success)
  summarizeFirmModuleSubmission: (id, submissionId, body) => adminRequest(`/api/firm-modules/admin/${id}/submissions/${submissionId}/summarize`,
    { method: 'POST', body: JSON.stringify(body || {}) }),
  // pkg76 — cross-module case digest: stored read (free) + generate (1 credit, consume-on-success)
  getClientCaseDigest:      (clientId)       => adminRequest(`/api/admin/clients/${clientId}/case-digest`),
  generateClientCaseDigest: (clientId, body) => adminRequest(`/api/admin/clients/${clientId}/case-digest`,
    { method: 'POST', body: JSON.stringify(body || {}) }),
  // pkg79 — LawMighty HQ operator portal (platform-owner only; server enforces)
  // pkg81 — Discovery Analysis v1: multipart inspect (custom fetch — FormData
  // must set its own boundary), attested run, report list, docx download.
  discoAnalysisInspect: async (clientId, formData) => {
    const token   = sessionStorage.getItem('ryanlaw_admin_token') || localStorage.getItem('ryanlaw_admin_token_p');
    const headers = {};
    if (token) headers.Authorization = `Bearer ${token}`;
    const res = await fetch(`${BASE}/api/discovery-analysis/admin/${clientId}/inspect`, {
      method: 'POST', headers, body: formData,
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) { const err = new Error(data.error || 'Inspect failed'); err.code = data.code; throw err; }
    return data;
  },
  discoAnalysisRun:     (clientId, body) => adminRequest(`/api/discovery-analysis/admin/${clientId}/run`,
    { method: 'POST', body: JSON.stringify(body) }),
  discoAnalysisReports: (clientId)       => adminRequest(`/api/discovery-analysis/admin/${clientId}/reports`),
  discoAnalysisDocx:    (reportId)       => adminDownload(`/api/discovery-analysis/admin/reports/${reportId}/docx`),
  // pkg83 — Step 1 of a deficiency run: multipart like inspect (FormData sets
  // its own boundary), one Word/PDF of the firm's served requests.
  discoAnalysisRequestsUpload: async (clientId, formData) => {
    const token   = sessionStorage.getItem('ryanlaw_admin_token') || localStorage.getItem('ryanlaw_admin_token_p');
    const headers = {};
    if (token) headers.Authorization = `Bearer ${token}`;
    const res = await fetch(`${BASE}/api/discovery-analysis/admin/${clientId}/requests`, {
      method: 'POST', headers, body: formData,
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) { const err = new Error(data.error || 'Upload failed'); err.code = data.code; err.status = res.status; throw err; }
    return data;
  },
  discoAnalysisLetter:  (reportId)       => adminDownload(`/api/discovery-analysis/admin/reports/${reportId}/letter`),
  // pkg161 — batched upload, one drop: start → add files (×N, multipart) →
  // finalize (returns the same shape as discoAnalysisInspect). Cancel frees
  // the staged files if the attorney abandons the upload.
  discoAnalysisDropStart:    (clientId)         => adminRequest(`/api/discovery-analysis/admin/${clientId}/drops`, { method: 'POST', body: '{}' }),
  discoAnalysisDropAddFiles: async (clientId, dropId, formData) => {
    const token   = sessionStorage.getItem('ryanlaw_admin_token') || localStorage.getItem('ryanlaw_admin_token_p');
    const headers = {};
    if (token) headers.Authorization = `Bearer ${token}`;
    const res = await fetch(`${BASE}/api/discovery-analysis/admin/${clientId}/drops/${dropId}/files`, {
      method: 'POST', headers, body: formData,
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) { const err = new Error(data.error || 'Upload failed'); err.code = data.code; err.status = res.status; throw err; }
    return data;
  },
  discoAnalysisDropFinalize: (clientId, dropId) => adminRequest(`/api/discovery-analysis/admin/${clientId}/drops/${dropId}/finalize`, { method: 'POST', body: '{}' }),
  discoAnalysisPleadingPrefill: (clientId)     => adminRequest(`/api/discovery-analysis/admin/${clientId}/pleading-prefill`), // pkg165
  discoAnalysisPleading:     (reportId, body)  => adminDownload(`/api/discovery-analysis/admin/reports/${reportId}/pleading`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }), // pkg165
  discoAnalysisResume:       (clientId, body)   => adminRequest(`/api/discovery-analysis/admin/${clientId}/resume`, { method: 'POST', body: JSON.stringify(body) }), // pkg163
  discoAnalysisDropCancel:   (clientId, dropId) => adminRequest(`/api/discovery-analysis/admin/${clientId}/drops/${dropId}`, { method: 'DELETE' }).catch(() => null),

  hqListFirms:   ()          => adminRequest('/api/hq/firms'),
  hqExtendTrial: (id, days)  => adminRequest(`/api/hq/firms/${id}/extend-trial`,
    { method: 'POST', body: JSON.stringify({ days }) }),
  // pkg87 — HQ growth. Every read below hits ONLY the firms table server-side
  // (D-87a): the usage counters are integers left on the firm row by the
  // nightly jobs/hqRollup.js, which holds the only RLS bypass and has no HTTP
  // route. Nothing here can reach a client name or a document.
  hqSuspendFirm:  (id, suspended)      => adminRequest(`/api/hq/firms/${id}/suspend`,
    { method: 'POST', body: JSON.stringify({ suspended }) }),
  // D-87q — `confirm` must be the typed subdomain; the server re-checks it and
  // hard-refuses if a live Stripe subscription exists.
  hqSetExemption: (id, exempt, confirm) => adminRequest(`/api/hq/firms/${id}/exemption`,
    { method: 'POST', body: JSON.stringify({ exempt, confirm }) }),
  hqListInvites:  ()                    => adminRequest('/api/hq/invites'),
  hqCreateInvite: (body)                => adminRequest('/api/hq/invites',
    { method: 'POST', body: JSON.stringify(body) }),
  hqRevokeInvite: (id)                  => adminRequest(`/api/hq/invites/${id}`, { method: 'DELETE' }),
  // pkg147 — HQ application queue (D-147c/d/e)
  hqListApplications:   ()              => adminRequest('/api/hq/applications'),
  hqApproveApplication: (id, body)      => adminRequest(`/api/hq/applications/${id}/approve`,
    { method: 'POST', body: JSON.stringify(body) }),
  hqRejectApplication:  (id, notify)    => adminRequest(`/api/hq/applications/${id}/reject`,
    { method: 'POST', body: JSON.stringify({ notify }) }),
  // pkg151 — onboarding emails (operator-sent templates, platform identity)
  hqListOnboardingTemplates: ()         => adminRequest('/api/hq/onboarding-emails'),
  hqPreviewOnboardingEmail:  (template, firstName) => adminRequest(
    `/api/hq/onboarding-emails/preview?template=${encodeURIComponent(template)}&first_name=${encodeURIComponent(firstName || '')}`),
  hqSendOnboardingEmail:     (body)     => adminRequest('/api/hq/onboarding-emails/send',
    { method: 'POST', body: JSON.stringify(body) }),
  // pkg159 — marketing emails
  hqMarketingTemplates:   ()            => adminRequest('/api/hq/marketing/templates'),
  hqMarketingLists:       ()            => adminRequest('/api/hq/marketing/lists'),
  hqMarketingList:        (id)          => adminRequest(`/api/hq/marketing/lists/${id}`),
  hqMarketingCreateList:  (body)        => adminRequest('/api/hq/marketing/lists',
    { method: 'POST', body: JSON.stringify(body) }),
  hqMarketingRender:      (body)        => adminRequest('/api/hq/marketing/render',
    { method: 'POST', body: JSON.stringify(body) }),
  hqMarketingRowExclude:  (id, excluded) => adminRequest(`/api/hq/marketing/rows/${id}`,
    { method: 'PATCH', body: JSON.stringify({ excluded }) }),
  hqMarketingMarkSent:    (id, template) => adminRequest(`/api/hq/marketing/rows/${id}/mark-sent`,
    { method: 'POST', body: JSON.stringify({ template }) }),
  hqMarketingSend:        (body)        => adminRequest('/api/hq/marketing/send',
    { method: 'POST', body: JSON.stringify(body) }),
  hqMarketingSuppression: ()            => adminRequest('/api/hq/marketing/suppression'),
  hqMarketingSuppress:    (email, reason) => adminRequest('/api/hq/marketing/suppression',
    { method: 'POST', body: JSON.stringify({ email, reason }) }),
  hqMarketingUnsuppress:  (id)          => adminRequest(`/api/hq/marketing/suppression/${id}`,
    { method: 'DELETE' }),
  hqListSubdomainReviews: ()            => adminRequest('/api/hq/subdomain-reviews'),
  hqResolveSubdomainReview: (id, resolution) => adminRequest(`/api/hq/subdomain-reviews/${id}`,
    { method: 'POST', body: JSON.stringify({ resolution }) }),
  // pkg75 — draft correspondence for a client (1 credit, draft-only, nothing stored or sent)
  draftClientCorrespondence: (clientId, body) => adminRequest(`/api/admin/clients/${clientId}/correspondence`,
    { method: 'POST', body: JSON.stringify(body) }),
  // pkg57 — share a completed document to a client's portal (revocable)
  shareFirmModuleSubmission:   (id, submissionId, clientId) => adminRequest(`/api/firm-modules/admin/${id}/submissions/${submissionId}/share`,
    { method: 'POST', body: JSON.stringify(clientId ? { client_id: clientId } : {}) }),
  unshareFirmModuleSubmission: (id, submissionId) => adminRequest(`/api/firm-modules/admin/${id}/submissions/${submissionId}/share`,
    { method: 'DELETE' }),
  downloadFirmModuleSubmission: (id, submissionId) =>
    adminDownload(`/api/firm-modules/admin/${id}/submissions/${submissionId}/download`),

  // ── pkg21a — case-type auto-assignment ─────────────────────────────────────
  // set returns { added, removed, removed_assignments, pending_clients };
  // pending_clients drives the "Assign to N existing clients?" prompt before
  // apply is called (D-21a.4 b — retroactive apply is never silent).
  // pkg35 — assembly review-screen support
  getModulePracticeAreas:       ()   => adminRequest('/api/firm-modules/admin/meta/practice-areas'),
  createInternalSubmission: (id, answers, linkedClientId) => // pkg36
    adminRequest(`/api/firm-modules/admin/${id}/submissions`,
      { method: 'POST', body: JSON.stringify({ answers, linked_client_id: linkedClientId || undefined }) }),
  downloadFirmModuleOriginal:   (id) => adminDownload(`/api/firm-modules/admin/${id}/original`),
  // pkg39 — re-run AI extraction against the stored original so pre-pkg39
  // modules gain source-text capture and can be tagged for exact-fill.
  // Replaces the wizard + template and drops the module back to draft.
  reextractFirmModuleQuote:     (id) => adminRequest(`/api/firm-modules/admin/${id}/reextract-quote`), // pkg100 (D-100g)
  reextractFirmModule:          (id) => adminRequest(`/api/firm-modules/admin/${id}/reextract`,
    { method: 'POST' }),
  // pkg41 — the FROZEN SNAPSHOT the client acknowledged (never a fresh
  // render) and the separate one-page Certificate of Acknowledgment.
  downloadAcknowledgedCopy: (id, submissionId) =>
    adminDownload(`/api/firm-modules/admin/${id}/submissions/${submissionId}/acknowledgment/download`),
  downloadAckCertificate:   (id, submissionId) =>
    adminDownload(`/api/firm-modules/admin/${id}/submissions/${submissionId}/acknowledgment/certificate`),
  // pkg42 — attorney submission management (D-41m/n). Delete cascades signed
  // acknowledgment records — the page confirms explicitly first. Edit updates
  // answers silently: signed acknowledgments untouched, pending invalidated.
  deleteFirmModuleSubmission: (id, submissionId) =>
    adminRequest(`/api/firm-modules/admin/${id}/submissions/${submissionId}`, { method: 'DELETE' }),
  updateFirmModuleSubmission: (id, submissionId, answers) =>
    adminRequest(`/api/firm-modules/admin/${id}/submissions/${submissionId}`,
      { method: 'PATCH', body: JSON.stringify({ answers }) }),
  // pkg43 — Prepare: the attorney's own fields, per assigned client. GET
  // returns the full answers object (prefill + show_if evaluation); POST
  // merges only attorney-owned values server-side.
  getPrepare:  (id, clientId)          => adminRequest(`/api/firm-modules/admin/${id}/prepare/${clientId}`),
  savePrepare: (id, clientId, answers, attorneySignature, attorneyUserId) => adminRequest(`/api/firm-modules/admin/${id}/prepare/${clientId}`,
    { method: 'POST', body: JSON.stringify({
        answers,
        ...(attorneySignature ? { attorney_signature: attorneySignature } : {}),
        ...(attorneyUserId ? { attorney_user_id: attorneyUserId } : {}), // pkg50
      }) }),

  getFirmModuleCaseTypes:   (id)              => adminRequest(`/api/firm-modules/admin/${id}/case-types`),
  setFirmModuleCaseTypes:   (id, caseTypeIds) => adminRequest(`/api/firm-modules/admin/${id}/case-types`,
    { method: 'PUT', body: JSON.stringify({ case_type_ids: caseTypeIds }) }),
  applyFirmModuleCaseTypes: (id)              => adminRequest(`/api/firm-modules/admin/${id}/case-types/apply`,
    { method: 'POST' }),

  // pkg171a — LawPay (8am) merchant connection. Status is view_billing (a
  // staff 403 hides the Firm Settings card); everything else is owner-only.
  // The connect start returns the secure.lawpay.com authorize URL — the
  // caller performs a top-level navigation; LawPay lands the browser back on
  // /admin/dashboard/firm-settings?lawpay=connected|denied|error.
  lawpayStatus:          ()      => adminRequest('/api/lawpay/status'),
  lawpayConnectStart:    ()      => adminRequest('/api/lawpay/connect/start', { method: 'POST', body: JSON.stringify({}) }),
  lawpaySignupStart:     (email) => adminRequest('/api/lawpay/signup/start', { method: 'POST', body: JSON.stringify(email ? { email } : {}) }), // pkg171c
  lawpayRefreshAccounts: ()      => adminRequest('/api/lawpay/accounts/refresh', { method: 'POST', body: JSON.stringify({}) }),
  lawpaySaveAccountMap:  (map)   => adminRequest('/api/lawpay/account-map', { method: 'PATCH', body: JSON.stringify(map) }),
  lawpaySetMode:         (mode)  => adminRequest('/api/lawpay/mode', { method: 'PATCH', body: JSON.stringify({ mode }) }),
  lawpayDisconnect:      ()      => adminRequest('/api/lawpay/connection', { method: 'DELETE' }),
  lawpayReconcile:       ()      => adminRequest('/api/lawpay/reconcile', { method: 'POST', body: JSON.stringify({}) }), // pkg173

  // pkg172a — LawPay payment links (lane 2): GET=view_billing, rest=edit_billing.
  paymentRequests:       (q)     => adminRequest('/api/payment-requests?' + new URLSearchParams(q).toString()),
  createPaymentRequest:  (body)  => adminRequest('/api/payment-requests', { method: 'POST', body: JSON.stringify(body) }),
  resendPaymentRequest:  (id, body) => adminRequest(`/api/payment-requests/${id}/resend`, { method: 'POST', body: JSON.stringify(body || {}) }),
  cancelPaymentRequest:  (id)    => adminRequest(`/api/payment-requests/${id}/cancel`, { method: 'POST', body: JSON.stringify({}) }),

  // pkg198 — masked saved methods and autopay status (view_billing). The
  // LawPay token is not in the response. Plan writes are owner or attorney.
  clientPaymentMethods: (clientId) => adminRequest(`/api/billing/${clientId}/payment-methods`),
  clientAutopay:        (clientId) => adminRequest(`/api/billing/${clientId}/autopay`),
  listPaymentPlans:     (params)   => adminRequest('/api/payment-plans' + queryString(params)),
  getPaymentPlan:       (id)       => adminRequest(`/api/payment-plans/${id}`),
  createPaymentPlan:    (body)     => adminRequest('/api/payment-plans', { method: 'POST', body: JSON.stringify(body) }),
  pausePaymentPlan:     (id)       => adminRequest(`/api/payment-plans/${id}/pause`, { method: 'POST', body: JSON.stringify({}) }),
  resumePaymentPlan:    (id)       => adminRequest(`/api/payment-plans/${id}/resume`, { method: 'POST', body: JSON.stringify({}) }),
  cancelPaymentPlan:    (id)       => adminRequest(`/api/payment-plans/${id}/cancel`, { method: 'POST', body: JSON.stringify({}) }),
  getReplenishment:     (clientId) => adminRequest(`/api/payment-plans/clients/${clientId}/replenishment`),
  saveReplenishment:    (clientId, body) => adminRequest(`/api/payment-plans/clients/${clientId}/replenishment`, { method: 'PUT', body: JSON.stringify(body) }),

  // pkg90 — full firm data export (owner-only on the server; a staff 403 on
  // the status read hides the Firm Settings card).
  firmExportStatus:     ()          => adminRequest('/api/firm-export'),
  firmExportRun:        ()          => adminRequest('/api/firm-export/run', { method: 'POST', body: JSON.stringify({}) }),
  firmExportRegenerate: (id)        => adminRequest(`/api/firm-export/${id}/regenerate`, { method: 'POST', body: JSON.stringify({}) }),
  firmExportDownload:   (id, token) => adminDownload(`/api/firm-export/${id}/download?token=${encodeURIComponent(token)}`),

  // pkg98 — MightyExchange (community module exchange). Adoption is free.
  // exchangePublish rejections: a 422 with code EXCHANGE_SCAN_BLOCKED carries
  // err.hits via the structured-error fields below.
  exchangeBrowse:   (params = {}) => adminRequest(`/api/exchange?${new URLSearchParams(params).toString()}`),
  exchangeGet:      (id)          => adminRequest(`/api/exchange/${id}`),
  exchangeMine:     ()            => adminRequest('/api/exchange/mine'),
  exchangePublishScan: (firmModuleId) => adminRequest('/api/exchange/publish/scan', { method: 'POST', body: JSON.stringify({ firm_module_id: firmModuleId }) }),
  exchangePublishConvert: (scanId, hitId) => adminRequest(`/api/exchange/publish/scan/${encodeURIComponent(scanId)}/convert`, { method: 'POST', body: JSON.stringify({ hit_id: hitId }) }),
  exchangePublish:  (payload)     => adminRequest('/api/exchange/publish', { method: 'POST', body: JSON.stringify(payload) }),
  exchangeAdopt:    (id)          => adminRequest(`/api/exchange/${id}/adopt`, { method: 'POST', body: JSON.stringify({}) }),
  exchangeWithdraw: (id)          => adminRequest(`/api/exchange/${id}/withdraw`, { method: 'POST', body: JSON.stringify({}) }),
  exchangePreview:  (id)          => adminRequest(`/api/exchange/${id}/document?preview=text`),
  exchangeDocument: (id)          => adminDownload(`/api/exchange/${id}/document`),
  hqExchangeList:   ()            => adminRequest('/api/hq/exchange'),
  hqExchangePreview:(id)          => adminRequest(`/api/hq/exchange/${id}/document?preview=text`),
  hqExchangeDocument:(id)         => adminDownload(`/api/hq/exchange/${id}/document`),
  hqExchangeReview: (id, action, note) => adminRequest(`/api/hq/exchange/${id}/review`, { method: 'POST', body: JSON.stringify({ action, note }) }),
  hqExchangeFeature:(id, featured)     => adminRequest(`/api/hq/exchange/${id}/feature`, { method: 'POST', body: JSON.stringify({ featured }) }),

  // pkg105a — device-session registry (self-scoped: the endpoints only ever
  // return/touch the signed-in admin's own sessions).
  listSessions:  ()   => adminRequest('/api/auth/sessions'),
  revokeSession: (id) => adminRequest(`/api/auth/sessions/${id}`, { method: 'DELETE' }),
};
